import ServiceIcon from "./ServiceIcon";

function Services({ t }) {

  return (
    <section id="services" className="services-section">

      <h2>{t.servicesTitle}</h2>

      <p className="services-subtitle">
        {t.servicesSubtitle}
      </p>

      <div className="services-grid">

        {t.servicesList.map((service, index) => (
          <div key={index} className="service-card">

            <div className="service-image">
              <ServiceIcon type={service.icon} />
            </div>

            <h3>{service.title}</h3>
            <p>{service.text}</p>

          </div>
        ))}

      </div>

    </section>
  );
}

export default Services;
